import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StatModule } from '@cargos/sprintpay-services';
import { isConfigPresent } from '@cargos/sprintpay-tools';
import { CoreModule } from 'src/app/shared/modules/core/core.module';
import { AccessoriesDefaultImplementationService } from 'src/app/shared/services/accessories/accessories-default-implementation.service';
import { AccessoriesService } from 'src/app/shared/services/accessories/accessories.service';
import { environment } from 'src/environments/environment';
import { BdpRoutingModule } from './bdp-routing.module';
import { BdpComponent } from './bdp.component';
import { HeaderBDPComponent } from './components/header/header.component';
import { BdpFacilityConfig } from './config/facility-config';
import { RecoverPasswordBDPModule } from './pages/auth/recover-password/recover-password.module';
import { ResetPasswordBDPModule } from './pages/auth/reset-password/reset-password.module';
import { ConfirmationBDPModule } from './pages/cart/confirmation-bdp/confirmation.module';
import { SearchModule } from './pages/search-awb/search-awb.module';
@NgModule({
    imports: [
        BdpRoutingModule,
        BrowserModule,
        SearchModule,
        CoreModule.forRoot(),
        ConfirmationBDPModule,
        RecoverPasswordBDPModule,
        ResetPasswordBDPModule,
        StatModule.forRoot({
            enableStatsig: isConfigPresent(environment.statsigSdkKey),
            sdkKey: environment.statsigSdkKey ?? '',
            user: {},
            options: {
                environment: {
                    tier: environment.environment === 'develop' ? 'development' : environment.environment,
                },
            },
        }),
    ],
    declarations: [BdpComponent, HeaderBDPComponent],
    bootstrap: [BdpComponent],
    providers: [
        {
            provide: AccessoriesService,
            useClass: AccessoriesDefaultImplementationService,
        },
        BdpFacilityConfig,
    ],
})
export class BDPModule {}
